import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderResponseDto } from 'shared/api';
import { orderApi } from '../../api/orderApi';
import { OrderRequest } from '../types/types';

export const getOrders = createAsyncThunk(
  'order/getOrders',
  async (params: {
    userId?: number;
    engineId?: number;
    status?: OrderResponseDto.status;
    workType?: OrderResponseDto.workType;
  }, { rejectWithValue }) => {
    try {
      const response = await orderApi.getOrders(params.userId, params.engineId, params.status, params.workType);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getOrderById = createAsyncThunk(
  'order/getById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await orderApi.getOrderById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createOrder = createAsyncThunk(
  'order/create',
  async (data: OrderRequest, { rejectWithValue }) => {
    try {
      const response = await orderApi.createOrder(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateOrder = createAsyncThunk(
  'order/update',
  async ({ id, data }: { id: number; data: OrderRequest }, { rejectWithValue }) => {
    try {
      const response = await orderApi.updateOrder(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteOrder = createAsyncThunk(
  'order/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await orderApi.deleteOrder(id);
      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const completeOrder = createAsyncThunk(
  'order/complete',
  async ({ id, reportFileUuid }: { id: number; reportFileUuid: string }, { rejectWithValue }) => {
    try {
      const response = await orderApi.completeOrder(id, reportFileUuid);
      return response;
    } catch (error) {
      console.error('order/completeOrder error:', error);
      return rejectWithValue(error);
    }
  },
);

// Удалены несуществующие методы API
